import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "col-12 col-md-10 mt-3 pr-5 page-content" }
const _hoisted_2 = { class: "section-heading" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", null, "Search results", -1)
const _hoisted_4 = { class: "float-right" }
const _hoisted_5 = { class: "row mt-3" }
const _hoisted_6 = { class: "col-12 col-md-12" }
const _hoisted_7 = {
  class: "section-block",
  style: {"height":"500px"}
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h2", null, "EMAILS", -1)
const _hoisted_9 = { class: "w-100" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "FROM"),
    /*#__PURE__*/_createElementVNode("th", null, "TO"),
    /*#__PURE__*/_createElementVNode("th", null, "SUBJECT"),
    /*#__PURE__*/_createElementVNode("th", null, "PREVIEW"),
    /*#__PURE__*/_createElementVNode("th", null, "DATE RECEIVED")
  ])
], -1)
const _hoisted_11 = { key: 0 }
const _hoisted_12 = {
  colspan: "2",
  style: {"text-align":"center","color":"red"}
}
const _hoisted_13 = { key: 1 }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "2",
    style: {"text-align":"center"}
  }, " No emails found ")
], -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { key: 2 }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "2",
    style: {"text-align":"center"}
  }, " Loading search results... ")
], -1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = { key: 3 }
const _hoisted_20 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VPagination = _resolveComponent("VPagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_VPagination, {
          pagination: _ctx.searchResultsPagination,
          "onUpdate:pagination": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchResultsPagination) = $event)),
          onPageChanged: _cache[1] || (_cache[1] = (page) => (_ctx.currentPage = page)),
          class: "float-right"
        }, null, 8, ["pagination"])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("table", _hoisted_9, [
            _hoisted_10,
            (_ctx.error != '')
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_11, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_12, _toDisplayString(_ctx.error), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.error == '' && !_ctx.loading && _ctx.emails.length == 0)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_13, _hoisted_15))
              : _createCommentVNode("", true),
            (_ctx.loading && _ctx.error.length != 0)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_16, _hoisted_18))
              : _createCommentVNode("", true),
            (!_ctx.loading && _ctx.companies.length > 0)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_19, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.companies, (comp) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: comp.entityId,
                      onClick: _withModifiers(($event: any) => (_ctx.goToCompany(comp.entityId)), ["prevent"])
                    }, [
                      _createElementVNode("td", null, _toDisplayString(comp.searchResultTitle), 1),
                      _createElementVNode("td", null, _toDisplayString(comp.searchResultDescription), 1)
                    ], 8, _hoisted_20))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}